import React from "react";
import { useSelector } from "react-redux";
import {
    IconButton,
    Toolbar,
    Tooltip,
    AppBar as AppBarMUI,
    Box,
    Avatar,
} from "@mui/material";
import ApiHandler from "../../../Handler/ApiHandler";
import { Menu, PowerSettingsNew } from "@mui/icons-material";
import { dispatch } from "../../../App";
import {
    DrawerMainLayoutClose,
    DrawerMainLayoutOpen,
} from "../../../Reducer/DrawerMainLayoutReducer/DrawerMainLayoutSlice";
import { AuthLogout } from "../../../Reducer/AuthReducer/AuthSlice";

function AppBar() {
    const authReducer = useSelector((state) => state.AuthReducer);
    const drawerMainLayoutReducer = useSelector((state) => state.DrawerMainLayoutReducer);
    const screenReducer = useSelector((state) => state.ScreenReducer);

    const [isTall, setIsTall] = React.useState(true);

    React.useEffect(() => {
        if (screenReducer.screen) {
            let isTallScreen =
                screenReducer.screen === "MD" ||
                screenReducer.screen === "LG" ||
                screenReducer.screen === "XL";
            if (isTallScreen !== isTall) setIsTall(isTallScreen);
        }
    }, [screenReducer.screen, isTall]);

    const changeDrawer = (isOpenDrawer) => {
        if (isOpenDrawer) dispatch(DrawerMainLayoutOpen());
        else dispatch(DrawerMainLayoutClose());
    };

    const logout = () => {
        dispatch(AuthLogout());
        ApiHandler.get({ route: "authentication_logout" }, (response) => { });
    };

    const initials = `${(authReducer.firstname || "").charAt(0)}${(authReducer.lastname || "").charAt(0)}`
        .toUpperCase();

    return (
        <AppBarMUI
            position="sticky"
            elevation={0}
            sx={{
                top: 0,
                background: "transparent",
                boxShadow: "none",
                padding: "10px 10px 6px 10px",
            }}
        >
            <Toolbar
                sx={{
                    minHeight: "64px !important",
                    borderRadius: "16px",
                    padding: "0px 10px",
                    border: "1px solid rgba(196, 175, 163, 0.35)",
                    background:
                        "linear-gradient(132deg, rgba(255,255,255,0.95) 0%, rgba(246,240,237,0.95) 55%, rgba(236,250,236,0.95) 100%)",
                    backdropFilter: "blur(8px)",
                    boxShadow: "0 12px 30px rgba(91, 70, 63, 0.12)",
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "10px",
                }}
            >
                {!isTall && (
                    <IconButton
                        onClick={() => changeDrawer(!drawerMainLayoutReducer.isOpen)}
                        sx={{
                            width: "42px",
                            height: "42px",
                            border: "1px solid rgba(164, 139, 129, 0.28)",
                            background: "rgba(255,255,255,0.9)",
                            color: "#654a40",
                            "&:hover": {
                                background: "#ffffff",
                            },
                        }}
                    >
                        <Menu sx={{ fontSize: "24px" }} />
                    </IconButton>
                )}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        flexGrow: 1,
                        minWidth: 0,
                    }}
                >
                    <Box
                        sx={{
                            minWidth: 0,
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: isTall ? "flex-start" : "flex-start",
                        }}
                    >
                        <img
                            src="/asset/image/logo.webp"
                            alt="In Out Skin"
                            style={{
                                height: isTall ? "34px" : "36px",
                                maxWidth: isTall ? "160px" : "180px",
                                width: "100%",
                                objectFit: "contain",
                                objectPosition: "left center",
                                display: "block",
                            }}
                        />
                    </Box>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <Avatar
                        sx={{
                            width: "34px",
                            height: "34px",
                            fontSize: "13px",
                            fontWeight: 700,
                            color: "#5e4438",
                            backgroundColor: "rgba(228, 191, 179, 0.8)",
                            border: "1px solid rgba(164, 139, 129, 0.28)",
                        }}
                    >
                        {initials}
                    </Avatar>
                    <Tooltip
                        title="Déconnexion"
                        aria-label="Déconnexion"
                    >
                        <IconButton
                            onClick={logout}
                            sx={{
                                width: "42px",
                                height: "42px",
                                border: "1px solid rgba(164, 139, 129, 0.28)",
                                color: "#654a40",
                                background: "rgba(255,255,255,0.9)",
                                "&:hover": {
                                    background: "#ffffff",
                                },
                            }}
                        >
                            <PowerSettingsNew sx={{ fontSize: "22px" }} />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Toolbar>
        </AppBarMUI>
    );
}

export default AppBar;
